import * as lottie from 'lottie-web/build/player/lottie.js';

// https://github.com/airbnb/lottie-web#setlocationhrefhref
lottie.setLocationHref(location.href);

const serversAniUrl = '/wp-content/themes/cablelabs-v23/src/js/modules/pages/gigabit-speeds/animations/LabToConsumer/animation.json';
const serverLightsAniUrl = '/wp-content/themes/cablelabs-v23/src/js/modules/pages/gigabit-speeds/animations/LabToConsumer/lights/animation.json';
const housesAniUrl = '/wp-content/themes/cablelabs-v23/src/js/modules/pages/gigabit-speeds/animations/GridHouse/animation.json';
const chartAniUrl = '/wp-content/themes/cablelabs-v23/src/js/modules/pages/gigabit-speeds/animations/BarGraph/data.json';
const housesChartAniUrl = '/wp-content/themes/cablelabs-v23/src/js/modules/pages/gigabit-speeds/animations/HousesChart/data.json';
const rocketsAniUrl = '/wp-content/themes/cablelabs-v23/src/js/modules/pages/gigabit-speeds/animations/Rockets/animation.json';

const serversAniConfig = {
  container: document.getElementById('LabToConsumerAni'),
  renderer: 'svg',
  loop: false,
  autoplay: false,
  path: serversAniUrl,
  progressiveLoad: true,
  rendererSettings: {
    title: 'A graphic showing 6 web servers connected to a neighborhood of homes. One home is larger than the rest with a wifi icon in the center of it and there are icons surrounding the home including a video icon, lock icon, temperature icon, lightbulb icon, and a microphone icon.',
  },
};

const serverLightsAniConfig = {
  container: document.getElementById('ServerLights'),
  renderer: 'svg',
  loop: true,
  autoplay: true,
  path: serverLightsAniUrl,
  rendererSettings: {
    title: 'The twinkling lights on the web servers from the lab to consumer animation.',
  },
};

const HousesAniConfig = {
  container: document.getElementById('HousesAni'),
  renderer: 'svg',
  loop: false,
  autoplay: false,
  path: housesAniUrl,
  rendererSettings: {
    title: 'A graphic of a grid of house icons that are either red, gray, or black.',
  },
};

const ChartAniConfig = {
  container: document.getElementById('BarChartAni'),
  renderer: 'svg',
  loop: false,
  autoplay: false,
  path: chartAniUrl,
  rendererSettings: {
    title: 'A chart graphic showing the max available download speeds in megabits per second for cable broadband service. The y-axis represents years, ranging from 2014 to 2019. The x-axis represents the percentage of U.S. cable housing units. The trend of the graph shows that 93% of housing units have 300 Mbps or better in 2019, as opposed to less than 10% in 2014.',
  },
};

const HousesChartAniConfig = {
  container: document.getElementById('HousesChartAni'),
  renderer: 'svg',
  loop: false,
  autoplay: false,
  path: housesChartAniUrl,
  rendererSettings: {
    title: 'A graphic showing that 9% of US homes had cable gigabit service available to them in December 2016 versus 82% today.',
  },
};

const RocketsAniConfig = {
  container: document.getElementById('RocketsAni'),
  renderer: 'svg',
  loop: false,
  autoplay: false,
  path: rocketsAniUrl,
  rendererSettings: {
    title: 'A graphic of 3 rockets blasting off. Each rocket has a different year underneath it, which are 2014, 2016 and 2019. The center rocket is colorized and bigger than the rest and has the text "1GB" in the center of it. The other two rockets are grayed out and smaller.',
  },
};

export {
  serversAniConfig,
  serverLightsAniConfig,
  HousesAniConfig,
  ChartAniConfig,
  HousesChartAniConfig,
  RocketsAniConfig,
};
